import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { IFiUserData, IFiUserModuleAccessRights } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { guid } from '@fi-shared/utils/guid';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { IUserCredentials } from '@fi-shared/fi-auth-shared/fi-auth-shared';
import { isDefined } from '@fi-shared/utils';
import { AppTextService } from '@fi-shared/app-text';
import { ICustomerUserInfo } from '@fi-shared/fi-shared-interfaces';

@Injectable()
export class AuthenticateService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoadingService: LoadingService,
        private appTextService: AppTextService,
    ) {}

    //Using String.format instead of GenerateUrl since we don't need token or API for login.
    Login(userCredentials: IUserCredentials) {
        const url = `Core/Authenticate/Login?applicationLanguage=${this.appTextService.getCurrentApplicationLanguage()}`;
        return this.fiBackend.fetchDataPost<IFiUserData>(url, this.getLoginParams(userCredentials), {
            supressErrorMessage: true,
        });
    }

    LoginSupport(UserId: number, IsMobile: boolean) {
        return this.fiBackend.fetchDataPost<IFiUserData>('Core/Authenticate/LoginSupport', {
            UserId: UserId,
            Uuid: `${UserId}`,
            IsMobile: IsMobile,
        });
    }

    ForceLogout(userCredentials: IUserCredentials) {
        return this.fiBackend.fetchDataPost<IFiUserData>(
            'core/authenticate/forcelogout',
            this.getLoginParams(userCredentials),
            { supressErrorMessage: true },
        );
    }

    getUsersForForgotPassword(userLoginOrContact: string) {
        const promise = this.fiBackend.fetchData<ICustomerUserInfo[]>(
            `Core/Authenticate/GetUsersForForgotPassword?userLoginOrContact=${encodeURIComponent(userLoginOrContact)}`,
        );
        return this.fiLoadingService.trackPromise(promise);
    }

    /*getUsersByLoginOrContact(userLoginOrContact: string) {
        const promise = this.fiBackend.fetchData<ILightWeightUser[]>(`Core/Authenticate/GetUsersByLoginOrContact?userLoginOrContact=${encodeURIComponent(userLoginOrContact)}`);
        return this.fiLoadingService.trackPromise(promise);
    }*/

    createResetPasswordLink(userId: number, userContact?: string) {
        let url = `Core/Authenticate/CreateResetPasswordLink/${userId}?applicationLanguage=${this.appTextService.getCurrentApplicationLanguage()}`;
        if (isDefined(userContact)) {
            url = url + `&userContact=${encodeURIComponent(userContact)}`;
        }
        const promise = this.fiBackend.fetchDataPost(url, undefined);
        return this.fiLoadingService.trackPromise(promise);
    }

    IsTokenValid(tokenToValidate) {
        if (!tokenToValidate) {
            return Promise.resolve(false);
        }

        return this.fiBackend
            .fetchData(`core/authenticate/istokenvalid/${tokenToValidate}`)
            .then((response) => response || false);
    }

    RefreshSession() {
        return this.fiBackend.fetchData('Core/Authenticate/RefreshSession');
    }

    GetModuleAccessRights() {
        return this.fiBackend.fetchData<IFiUserModuleAccessRights>('core/role/GetModuleAccessRights');
    }

    SetupExtendedAccessSession(extendedAccessRights) {
        return this.fiBackend.fetchDataPost<IFiUserData>(
            'Core/Authenticate/SetupExtendedAccessSession',
            extendedAccessRights,
        );
    }

    CloseExtendedAccessSession() {
        return this.fiBackend.fetchDataPost<IFiUserData>('Core/Authenticate/CloseExtendedAccessSession');
    }

    GetUserData() {
        return this.fiBackend.fetchData<IFiUserData>('Core/Authenticate/GetUserData');
    }

    isMagicLinkValid(magicLink: string) {
        return this.fiBackend.fetchData<boolean>('Core/Authenticate/IsMagicLinkValid/' + magicLink, {
            supressErrorMessage: true,
        });
    }

    requestNewMagicLink(magicLink: string) {
        return this.fiLoadingService.trackPromise(
            this.fiBackend.fetchDataPost('Core/Authenticate/RequestNewMagicLink/' + magicLink, undefined),
        );
    }

    updatePassword(magicLink: string, password: string) {
        return this.fiBackend.fetchDataPost<string>('Core/Authenticate/UpdatePassword', {
            magicLink: magicLink,
            password: password,
        });
    }

    private getLoginParams(userCredentials: IUserCredentials) {
        return Object.assign(this.getBaseLoginParams(), {
            Login: userCredentials.Login,
            Password: userCredentials.Password,
            ShouldStayLoggedIn: userCredentials.ShouldStayLoggedIn,
        });
    }

    getBaseLoginParams() {
        var uuid = localStorage.getItem('fi-uuid');
        if (!uuid) {
            uuid = guid();
            localStorage.setItem('fi-uuid', uuid);
        }
        /*var loggedUsersFromStorage = this.sessionService.getLoggedUsersFromStorage();
        var isLoggedInOtherTab = loggedUsersFromStorage.indexOf(userCredential.UserName.toLowerCase()) !== -1;*/
        const isLoggedInOtherTab = false;
        return { uuid: uuid, isLoggedInOtherTab: isLoggedInOtherTab };
    }

    debugApi2MagicLink() {
        /*this.fiBackend.fetchDataPost('api2/Auth/LoginWithMagicLink', {
            Token: '212f86c2-246e-4a97-8aff-e08ef1d0f667',
            Uuid: '',
            CustomerUrl: 'stabletesting.chainformation.com',
        });*/
    }
}
